import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatProgressBar } from '@angular/material/progress-bar';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IS_HEADER_HIDDEN } from './core/constants/embed.constants';
import { GlobalErrorHandlerService } from './core/error-handler/global-error-handler.service';
import { CheckForUpdateService } from './core/services/check-for-update.service';
import { DialogCloseButtonService } from './core/services/dialog-close-button.service';
import { InternetStatusService } from './core/services/internet-status.service';
import { LoadingService } from './core/services/loading.service';
import { IPageHeader, PageHeaderComponent } from './layout/page-header/page-header.component';
import { ToolbarComponent } from './layout/toolbar/toolbar.component';

@Component({
  imports: [RouterOutlet, ToolbarComponent, PageHeaderComponent, MatProgressBar, TranslateModule, NgIf, AsyncPipe],
  selector: 'app-root',
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  public readonly isIframe = window.self !== window.top;
  public readonly isHeaderHidden: boolean = IS_HEADER_HIDDEN;

  title = 'scw-action-tracker';
  isLoading$: Observable<boolean> = LoadingService.loading$;
  public readonly pageConfiguration = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((): IPageHeader['appComponent'] => {
        let child = this.router.routerState.snapshot.root;

        while (child.firstChild) {
          child = child.firstChild;
        }

        return child.data?.['appComponent'];
      }),
    ),
  );

  constructor(
    private readonly checkForUpdateService: CheckForUpdateService,
    private readonly internetStatus: InternetStatusService,
    private readonly dialogCloseButtonService: DialogCloseButtonService,
    translate: TranslateService,
  ) {
    translate.setDefaultLang('en');
    this.internetStatus.start();
    this.dialogCloseButtonService.start();
  }

  public ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        if (event.error && event.error instanceof Error) {
          const isChunkError: boolean = GlobalErrorHandlerService.handleChunkError({
            err: event.error,
            from: 'router',
          });

          if (isChunkError) {
            return;
          }
        }
      }
    });
  }
}
